<template>
  <footer class="footer">
    <div class="section">
      <div class="footer_box">
        <div class="footer-main">
          <div class="footer-brand">
            <img class="logo-footer" src="@/assets/images/logo.png" alt="ChatExcel" />
            <div class="footer-qr">
              <div class="add_p">扫码关注公众号</div>
              <img class="official-qr" src="@/assets/images/qrCode/official-account.png" alt="微信公众号二维码" />
            </div>
          </div>

          <div class="footer-content">
            <!-- 业务意图：统一展示元空三条正式产品线，避免旧版多级栏目导致入口分散。 -->
            <div
              class="product-grid"
              :class="{ 'product-grid--hidden': !showFooterProductGrid }"
              :aria-hidden="!showFooterProductGrid"
            >
              <div class="product-info">
                <a class="product-title-link" href="https://www.chatexcel.com/homesite/" target="_blank" rel="noopener noreferrer">元空AI Work</a>
                <p>元空旗下的 AI 办公平台</p>
              </div>
              <div class="product-info">
                <a class="product-title-link" href="https://www.e2sci.com/" target="_blank" rel="noopener noreferrer">元空AI Science</a>
                <p>元空旗下的 AI 科研平台</p>
              </div>
              <div class="product-info">
                <a class="product-title-link" href="https://www.yuankongai.com/pages/AIStation" target="_blank" rel="noopener noreferrer">元空AI Station</a>
                <p>元空旗下的端侧AI产品</p>
              </div>
            </div>
            <nav class="footer-links" aria-label="页脚链接">
              <a href="https://chatexcel.com/blog/tutorial/" target="_blank" rel="noopener noreferrer">使用教程</a>
              <a href="https://www.yuankongai.com/pages/about" target="_blank" rel="noopener noreferrer">关于我们</a>
              <a href="https://www.chatexcel.com/blog" target="_blank" rel="noopener noreferrer">新闻资讯</a>
              <a href="https://www.yuankongai.com/pages/contact" target="_blank" rel="noopener noreferrer">联系我们</a>
            </nav>
          </div>
        </div>

        <div class="footer-bottom">
          <div class="footer-records">
            <a target="_blank" rel="noopener noreferrer" class="beian-link" href="https://beian.miit.gov.cn/">
              Copyright<img src="@/assets/images/copyright.png" alt="" />北京元空智能科技有限公司 | 京ICP备2024050141号-2
            </a>
            <a target="_blank" rel="noopener noreferrer" class="beian-link" href="https://beian.miit.gov.cn/">
              <img src="@/assets/images/beian.jpg" alt="" />京公网安备11010802045331号
            </a>
          </div>

          <div class="icon_div" aria-label="社交媒体">
            <a href="https://www.douyin.com/user/MS4wLjABAAAAV5MjKN73g-fKdRFpjbunbJLuz73glcYxfRqxyolzM737v7K75E-x5ifWt6MGRy4L?previous_page=app_code_link"
              target="_blank" rel="noopener noreferrer">
              <img src="@/assets/images/bottom_icon/icon-douyin.png" alt="抖音" />
            </a>
            <a href="https://space.bilibili.com/3546575265597616?spm_id_from=333.1007.0.0" target="_blank" rel="noopener noreferrer">
              <img src="@/assets/images/bottom_icon/icon-bilibili.png" alt="哔哩哔哩" />
            </a>
            <a href="https://www.xiaohongshu.com/user/profile/654a1558000000000301fa44?xsec_token=YBW-Fc4zFuEf1Vq1UH3RadtpML4awxHHScB4JxQeE2UFI=&xsec_source=app_share&xhsshare=CopyLink&appuid=654a1558000000000301fa44&apptime=1755860503&share_id=94f2a660ff414b4ebd257287d3f122a5"
              target="_blank" rel="noopener noreferrer">
              <img src="@/assets/images/bottom_icon/icon-xiaohongshu.png" alt="小红书" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "myFooter",
  data() {
    return {
      // 业务意图：online 暂时隐藏产品入口，但保留原布局空间；恢复时将开关改为 true。
      showFooterProductGrid: false,
    };
  },
};
</script>

<style scoped>
.footer {
  color: #666;
  background: #f7f8f7;
  border-top: 1px solid #eef2f0;
}

.footer .section {
  display: block;
  width: min(calc(100% - 48px), 1280px);
  min-width: 0;
  max-width: 1280px;
  margin: 0 auto;
  border-top: 0;
}

.footer_box {
  width: 100%;
  margin: 0;
  padding: 52px 0 24px;
}

.footer-main {
  display: flex;
  align-items: flex-start;
  gap: clamp(48px, 7vw, 104px);
}

.footer-brand {
  flex: 0 0 240px;
}

.logo-footer {
  display: block;
  width: 170px;
  height: 30px !important;
  object-fit: contain;
}

.brand-desc {
  margin-top: 12px;
  color: #66716d;
  font-size: 13px;
  line-height: 22px;
}

.msg_div {
  display: flex;
  align-items: center;
  margin-top: 16px;
  color: #4f5a56;
  font-size: 13px;
  line-height: 20px;
}

.msg_div img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.brand-address {
  margin: 4px 0 0;
  color: #66716d;
  font-size: 13px;
  line-height: 22px;
}

.footer-qr {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 18px;
}

.footer_box .add_p {
  order: 2;
  margin: 0;
  color: #4f5a56;
  font-size: 13px;
  line-height: 22px;
  white-space: nowrap;
}

.official-qr {
  display: block;
  order: 1;
  width: 108px;
  height: 108px;
  margin-top: 0;
  border-radius: 4px;
  object-fit: cover;
}

.footer-content {
  flex: 1;
  min-width: 0;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.product-grid--hidden {
  visibility: hidden;
}

.product-info {
  min-width: 0;
}

.product-title-link {
  display: inline-block;
  color: #0d211d;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-decoration: none;
  transition: color 0.2s ease;
}

.product-title-link:hover {
  color: #35ad84;
}

.product-info p {
  margin: 10px 0 0;
  color: #66716d;
  font-size: 13px;
  line-height: 22px;
}

.footer-content .footer-links {
  margin-top: 32px;
}

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-top: 42px;
  padding-top: 18px;
  border-top: 1px solid #e5eae7;
}

.footer-links,
.footer-records,
.icon_div {
  display: flex;
  align-items: center;
}

.footer-links {
  display: flex;
  gap: 24px;
  font-size: 13px;
}

.footer-links a,
.beian-link {
  color: #66716d;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-links a:hover,
.beian-link:hover {
  color: #35ad84;
}

.footer-records {
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  color: #999;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}

.beian-link {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.beian-link img {
  display: block;
  width: 12px;
  height: auto;
  margin: 0 4px;
  object-fit: contain;
}

.beian-link:last-child img {
  width: 20px;
  margin-left: 0;
}

.icon_div {
  flex: 0 0 auto;
  gap: 14px;
}

.icon_div a {
  display: inline-flex;
  align-items: center;
}

.icon_div img {
  width: 18px;
  height: 18px;
  object-fit: contain;
  transition: transform 0.2s ease;
}

.icon_div a:hover img {
  transform: scale(1.1);
}

@media screen and (max-width: 1080px) {
  .footer-main {
    gap: 36px;
  }

  .footer-brand {
    flex-basis: 210px;
  }

  .product-grid {
    grid-template-columns: 1fr;
  }

  .footer-bottom {
    align-items: flex-start;
    flex-wrap: wrap;
  }
}

@media screen and (max-width: 720px) {
  .footer .section {
    width: calc(100% - 32px);
  }

  .footer_box {
    padding-top: 36px;
  }

  .footer-main {
    display: block;
  }

  .footer-brand {
    width: 100%;
  }

  .footer-content {
    margin-top: 32px;
  }

  .footer-content .footer-links {
    margin-top: 24px;
  }

  .footer-bottom {
    display: block;
    margin-top: 32px;
  }

  .footer-records {
    justify-content: flex-start;
    margin-top: 18px;
    text-align: left;
  }

  .icon_div {
    margin-top: 18px;
  }
}
</style>
